import { Check } from 'lucide-react';

import useAPRButton from './useAPRButton';

import { SplitKey } from '../useAPRs';

export interface APRButtonProps {
  splitKey: SplitKey;
}

const APRButton: React.FunctionComponent<APRButtonProps> = function ({
  splitKey,
}) {
  const {
    buttonId,
    buttonClassName,
    onClick,
    indicatorClassName,
    title,
    subheading,
    minimumMonthlyCost,
    points,
  } = useAPRButton(splitKey);
  return (
    <button
      type="button"
      id={buttonId}
      onClick={onClick}
      className={buttonClassName}
    >
      <div className="flex flex-row gap-x-4 mb-2">
        <div className={indicatorClassName}>
          <Check
            size={16}
            className="text-neutral-000 stroke-neutral-000 m-auto"
          />
        </div>
        <div className="flex flex-col w-full">
          <div className="flex flex-row gap-x-3 justify-between">
            <div className="flex flex-col text-left">
              <h2 className="text-14-18-em md:text-16-20-em text-neutral-800">
                {title}
              </h2>
              <h3 className="text-12-18 md:text-14-22 text-neutral-700">
                {subheading}
              </h3>
            </div>
            <div className="flex flex-col text-right">
              <h2 className="text-14-18-em md:text-16-20-em text-neutral-800 whitespace-nowrap">
                {minimumMonthlyCost}
              </h2>
              <h3 className="text-12-18 md:text-14-22 text-neutral-700">
                per month
              </h3>
            </div>
          </div>
        </div>
      </div>
      {points.map((point) => (
        <div
          className="flex flex-row gap-x-2 mb-1 last:mb-0 text-left"
          key={point}
        >
          <div className="w-1 h-1 min-w-1 bg-neutral-700 rounded-full mt-1.75" />
          <span className="text-12-18 text-neutral-700">{point}</span>
        </div>
      ))}
    </button>
  );
};

export default APRButton;
